import { createContext } from 'react';

import type { ContextValue } from './Notification.types';

export const NotificationContext = createContext<ContextValue | undefined>(
  undefined
);
